export default "__VITE_ASSET__DGha8w6N__"